/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
export type OrderAddressType = ('billing' | 'licensee' | '%future added value');
export type OrderPaymentStatus = ('PaymentPending' | 'PaymentReceived' | '%future added value');
export type PromoCodeDiscountType = ('CartFixed' | 'CartPercent' | 'ItemFixed' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type checkout_viewer$ref: FragmentReference;
export type checkout_viewer = {|
  +checkout: ?{|
    +id: string,
    +currency_code: ?string,
    +currency_rate: ?number,
    +discount: ?number,
    +invoice_number: ?number,
    +order_date: ?any,
    +payment_due_date: ?any,
    +payment_received_date: ?any,
    +payment_status: ?OrderPaymentStatus,
    +subtotal: ?number,
    +total: ?number,
    +license_line_items: ?$ReadOnlyArray<?{|
      +id: string,
      +amount: ?number,
      +discount_amount: ?number,
      +track: ?{|
        +id: string,
        +internal_id: ?number,
        +title: ?string,
        +added_to_cart: ?boolean,
        +slug: ?string,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
        +artist: ?{|
          +id: string,
          +name: ?string,
          +slug: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
        |},
        +terms: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +is_highlighted: ?boolean,
              +name: ?string,
              +parent_id: ?string,
              +taxonomy: ?{|
                +id: string,
                +internal_id: ?number,
                +name: ?string,
              |},
            |},
          |}>,
        |},
      |},
      +license: ?{|
        +id: string,
        +usages: ?$ReadOnlyArray<?{|
          +id: string,
          +license_id: ?number,
          +air_date: ?any,
          +components: ?$ReadOnlyArray<?{|
            +id: string,
            +component_id: ?number,
            +name: ?string,
            +type: ?string,
          |}>,
        |}>,
      |},
    |}>,
    +general_line_items: ?$ReadOnlyArray<?{|
      +id: string,
      +description: ?string,
      +amount: ?number,
      +discount_amount: ?number,
    |}>,
    +promo_code_line_item: ?{|
      +id: string,
      +code: ?string,
      +discount_type: ?PromoCodeDiscountType,
      +discount_type_amount: ?number,
    |},
    +tax_line_items: ?$ReadOnlyArray<?{|
      +id: string,
      +priority: ?number,
      +tax_name: ?string,
      +rate: ?number,
      +amount: ?number,
    |}>,
    +licensee_address: ?{|
      +id: string,
      +type: OrderAddressType,
      +name: string,
      +company: ?string,
      +company_type_id: ?string,
      +company_type: ?{|
        +id: string,
        +name: ?string,
      |},
      +line_1: string,
      +line_2: ?string,
      +city: string,
      +postal_code: string,
      +subdivision_code: string,
      +country_code: string,
    |},
    +billing_address: ?{|
      +id: string,
      +type: OrderAddressType,
      +name: string,
      +company: ?string,
      +company_type_id: ?string,
      +company_type: ?{|
        +id: string,
        +name: ?string,
      |},
      +line_1: string,
      +line_2: ?string,
      +city: string,
      +postal_code: string,
      +subdivision_code: string,
      +country_code: string,
    |},
    +project_details: ?{|
      +brand: ?string,
      +product: ?string,
      +reference: ?string,
      +po_number: ?string,
      +notes: ?string,
    |},
    +authorized_representative: ?{|
      +name: ?string,
      +email: ?string,
      +phone: ?string,
      +role_id: ?string,
      +role: ?{|
        +id: string,
        +name: ?string,
      |},
    |},
  |},
  +profile: ?{|
    +id: string,
    +user_id: string,
    +email: ?string,
    +external_provider: ?string,
    +first_name: ?string,
    +is_new_user: boolean,
    +ga_account_goal_sent: boolean,
    +last_name: ?string,
    +picture: ?string,
    +company_name: ?string,
    +company_size: ?{|
      +name: ?string,
    |},
    +industry: ?{|
      +name: ?string,
    |},
    +job_type: ?{|
      +name: ?string,
    |},
  |},
  +company_types: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
      |},
    |}>,
  |},
  +representative_roles: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
      |},
    |}>,
  |},
  +selected_currency: ?Currency,
  +$refType: checkout_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "discount_amount",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "internal_id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    },
    v5,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v8 = [
  v0,
  v7
],
v9 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_1",
    "args": null,
    "storageKey": null
  },
  v0,
  v7,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "company",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "company_type_id",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "company_type",
    "storageKey": null,
    "args": null,
    "concreteType": "CompanyType",
    "plural": false,
    "selections": v8
  },
  v5,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_2",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_code",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_code",
    "args": null,
    "storageKey": null
  }
],
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v11 = [
  v7
];
return {
  "kind": "Fragment",
  "name": "checkout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "country_code",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "subdivision_code",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "checkout",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "country_code",
          "variableName": "country_code",
          "type": "String"
        },
        {
          "kind": "Variable",
          "name": "subdivision_code",
          "variableName": "subdivision_code",
          "type": "String"
        }
      ],
      "concreteType": "Order",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "subtotal",
          "args": null,
          "storageKey": null
        },
        v0,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "currency_rate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "invoice_number",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "order_date",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "payment_due_date",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "payment_received_date",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "payment_status",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "currency_code",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "total",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "license_line_items",
          "storageKey": null,
          "args": null,
          "concreteType": "LicenseLineItem",
          "plural": true,
          "selections": [
            v0,
            v1,
            v2,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "track",
              "storageKey": null,
              "args": null,
              "concreteType": "TrackSearchResult",
              "plural": false,
              "selections": [
                v0,
                v3,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "added_to_cart",
                  "args": null,
                  "storageKey": null
                },
                v4,
                v6,
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "artist",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Artist",
                  "plural": false,
                  "selections": [
                    v0,
                    v7,
                    v4,
                    v6
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "terms",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TaxonomyTermConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "TaxonomyTermEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "TaxonomyTerm",
                          "plural": false,
                          "selections": [
                            v0,
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "is_highlighted",
                              "args": null,
                              "storageKey": null
                            },
                            v7,
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "parent_id",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "taxonomy",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "Taxonomy",
                              "plural": false,
                              "selections": [
                                v0,
                                v3,
                                v7
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "license",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicense",
              "plural": false,
              "selections": [
                v0,
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "usages",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "StandardLicenseUsage",
                  "plural": true,
                  "selections": [
                    v0,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "license_id",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "air_date",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "components",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "StandardLicenseUsageComponent",
                      "plural": true,
                      "selections": [
                        v0,
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "component_id",
                          "args": null,
                          "storageKey": null
                        },
                        v7,
                        v5
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "general_line_items",
          "storageKey": null,
          "args": null,
          "concreteType": "GeneralLineItem",
          "plural": true,
          "selections": [
            v0,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "description",
              "args": null,
              "storageKey": null
            },
            v1,
            v2
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "promo_code_line_item",
          "storageKey": null,
          "args": null,
          "concreteType": "PromoCodeLineItem",
          "plural": false,
          "selections": [
            v0,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "code",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "discount_type",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "discount_type_amount",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tax_line_items",
          "storageKey": null,
          "args": null,
          "concreteType": "TaxLineItem",
          "plural": true,
          "selections": [
            v0,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "priority",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "tax_name",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "rate",
              "args": null,
              "storageKey": null
            },
            v1
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "licensee_address",
          "storageKey": null,
          "args": null,
          "concreteType": "OrderAddress",
          "plural": false,
          "selections": v9
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "billing_address",
          "storageKey": null,
          "args": null,
          "concreteType": "OrderAddress",
          "plural": false,
          "selections": v9
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "project_details",
          "storageKey": null,
          "args": null,
          "concreteType": "ProjectDetails",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "brand",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "product",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "reference",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "po_number",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "notes",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "authorized_representative",
          "storageKey": null,
          "args": null,
          "concreteType": "AuthorizedRepresentative",
          "plural": false,
          "selections": [
            v7,
            v10,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "phone",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "role_id",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "role",
              "storageKey": null,
              "args": null,
              "concreteType": "RepresentativeRole",
              "plural": false,
              "selections": v8
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "ga_account_goal_sent",
          "args": null,
          "storageKey": null
        },
        v0,
        v10,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "external_provider",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "first_name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "is_new_user",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "user_id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "last_name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "picture",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "company_name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "company_size",
          "storageKey": null,
          "args": null,
          "concreteType": "CompanySize",
          "plural": false,
          "selections": v11
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "industry",
          "storageKey": null,
          "args": null,
          "concreteType": "Industry",
          "plural": false,
          "selections": v11
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "job_type",
          "storageKey": null,
          "args": null,
          "concreteType": "JobType",
          "plural": false,
          "selections": v11
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "company_types",
      "storageKey": null,
      "args": null,
      "concreteType": "CompanyTypeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CompanyTypeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "CompanyType",
              "plural": false,
              "selections": v8
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "representative_roles",
      "storageKey": null,
      "args": null,
      "concreteType": "RepresentativeRoleConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "RepresentativeRoleEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "RepresentativeRole",
              "plural": false,
              "selections": v8
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "selected_currency",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
(node/*: any*/).hash = 'af693b65b79c7991f3acf9c902a551b7';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/checkout_viewer.graphql.js